import { DatePicker } from '@ddc-webplatform/cmsc-components';
import dayjs from 'dayjs';
import React, { memo } from 'react';
import { SitemapDatePickerProps } from 'models';

const SitemapDatePicker = ({
	open,
	onOpen,
	onClose,
	value,
	onChange,
	placement = 'top-start'
}: SitemapDatePickerProps) => {
	return (
		<DatePicker
			format="MM/DD/YYYY"
			views={['year', 'month', 'day']}
			slotProps={{
				root: {
					closeOnSelect: false,
					open,
					onOpen,
					onClose,
					onAccept: onClose,
					disablePast: true,
					value: value ? dayjs(value) : null,
					onChange,
					slotProps: {
						popper: {
							sx: { zIndex: 99999 },
							disablePortal: true,
							placement
						},
						desktopPaper: {
							elevation: 24,
							sx: {
								bgcolor: '#333333',
								backgroundImage: 'none'
							}
						},
						actionBar: {
							actions: ['cancel', 'accept'],
							sx: {
								borderTop: '1px solid rgba(255, 255, 255, 0.12)',
								'& button': { textTransform: 'uppercase' }
							}
						},
						textField: {
							size: 'small',
							fullWidth: true,
							onClick: onOpen,
							sx: {
								'& input': { fontSize: 16, cursor: 'pointer' },
								...(!value && {
									'& .MuiPickersSectionList-root': { visibility: 'hidden' }
								})
							}
						},
						field: {
							clearable: true
						}
					}
				}
			}}
		/>
	);
};

export default memo(SitemapDatePicker);
